import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';

import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  Sponsors,
  Photo,
} from './styles';

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';
import SpeakersGrid from '../../components/SpeakersGrid';


import Publicas from './modules/publicas';
import Programacao from '../Program';
import Vimeo from '../../components/Vimeo';
import GaleriaFotos from '../GaleriaFotos';
import ContagemRegressiva from '../../components/ContagemRegressiva';
import Logo from '../../components/Logo';
import Speakers from '../Speakers';
import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';
import Sobre from '../Sobre';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { addModal, removeModal } = useModal();
  const formRef = useRef<FormHandles>(null);
  const [cardLayout, setCardLayout] = useState([] as Array<JSX.Element>);
  const { readPages } = usePages();

  const [pages, setPages] = useState(readPages());

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        const { email, password } = data;

        await signIn({ email, password });
        history.push('/dashboard');
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, history],
  );

  const buildCard: React.FC<IPublicData> = ({ icon, title, text }) => {
    return (
      <div
        onClick={() =>
          setCardLayout([<Publicas icon={icon} text={text} title={title} />])
        }
      >
        {icon({})}
        <p>{title}</p>
      </div>
    );
  };

  return (
    <>
      <Capa
        style={{
          minHeight: '80vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div >
          <img
            style={{ width: '100%', maxWidth: '600px' }}
            className=" shadowed"
            src="/apoio/lettering-v4.png"
          />

        </div>
        <div >


          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SponsorsList />

            <aside style={{ width: '100%', marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/certificados" style={{ margin: '10px' }}>
                <div className="titleSkewRight">
                  <h3 className="titleSkewRight">Certificados</h3>
                </div>
              </Link>

              <Link to="/inscricao" style={{ margin: '10px' }}>
                <div className="titleSkewRightDark">
                  <h3 className="titleSkewRightDark">inscreva-se!</h3>
                </div>
              </Link>
              {/*  <Link to="/certificados" style={{margin: '10px'}}>
              <div className="titleSkewRightDark">
                <h3 className="titleSkewRightDark">Certificados</h3>
              </div>
          </Link> */}
              <Link to="/login" style={{ margin: '10px' }}>
                <div className="titleSkewRight">
                  <h3 className="titleSkewRight">Acessar</h3>
                </div>
              </Link>
            </aside>
          </div>

        </div>


      </Capa>


      <ContainerWhite style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ color: '#075E60' }}>IV Fórum da Qualidade do Hospital Mãe de Deus</h2>
        <p style={{ width: '100%', maxWidth: '600px', margin: '20px auto', textAlign: 'justify', lineHeight: '24px', fontSize: '18px', color: '#075E60' }}>
          O IV Fórum da Qualidade do Hospital Mãe de Deus aborda, nesta edição, a reflexão sobre o impacto da prática assistencial como pilar que sustenta a qualidade da prestação dos serviços de saúde. Desta forma, o tema central, que é “A prática assistencial como protagonista da qualidade”, discute ideias que fundamentam a prática assistencial associados à inovação, tecnologia e centralidade no paciente. <br /><br />
          Esses e outros tópicos serão debatidos em palestras com renomados nomes durante o evento. Além disso, será enfatizada uma abordagem que possa gerar valor ao público expectador.<br /><br />
          As palestras ocorrerão online e presencial, com a possibilidade de interação com o público por meio de perguntas que poderão ser enviadas no final de cada sessão. O evento é gratuito e busca compartilhar conhecimento sobre essa temática com o público presente.  <br /><br />
          Para participar, é necessário apenas realizar inscrição prévia para receber o certificado. Confira a programação abaixo e participe deste evento para fazer a diferença na entrega de uma saúde mais qualificada e segura!
        </p>
      </ContainerWhite>

      <ContainerWhite background="none" id="programacao">
        <div className="p50  tableItem">
          <h2>Programação</h2>
          <p>IV Fórum da Qualidade do Hospital Mãe de Deus</p>
          <h2>30 de março de 2023</h2>
          <table>
            <tbody>
              <tr><td>8h30</td><td>Abertura </td></tr>
              <tr><td>9h</td><td>Segurança do paciente em cirurgia robótica - Norberto Martins - Hospital Mãe de Deus</td></tr>
              <tr><td>10h</td><td> Intervalo</td></tr>
              <tr><td>10h30h</td><td>Painel: Tecnologias para segurança do paciente
                <br />Inserção virtual de cateter central de inserção periférica (Virtua) - Cristiane Vizcaychipi – Consultora técnica BD
                <br />Prevenção de quedas e lesões por pressão - Delmonte Friedrich - CEO StakeCare
                <br />Computação cognitiva e machine learning - Cristian Rocha - CEO Laura

              </td></tr>


              <tr><td>12h</td><td>INTERVALO ALMOÇO</td></tr>
              <tr><td>12h30min às 13h</td><td>*SIMPÓSIO SATÉLITE -  Terapia Infusional e o impacto na segurança do paciente – palestrante Carlos Damasceno (Consultor clínico de Marketing da BD)</td></tr>
              <tr><td>13h30</td><td>Apresentação de trabalhos orais e premiação do Programa Interno de Qualidade do Hospital Mãe de Deus</td></tr>
              <tr><td>14h30</td><td>Estratégias para uso seguro de medicamentos em idosos no âmbito hospitalar - Bruno Simas da Rocha - Hospital de Clínicas de Porto Alegre</td></tr>
              <tr><td>15h30</td><td>Intervalo</td></tr>
              <tr><td>16h</td><td>Ferramentas para impactar a experiência do paciente
                <br />Maiara Anschau Floriani - Santa Casa de Misericórdia de Porto Alegre
              </td></tr>
              <tr><td>17h</td><td>Encerramento</td></tr>

            </tbody>
          </table>
        </div>
      </ContainerWhite>



      <ContainerWhite style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ color: '#075E60' }}>I Summit Internacional de Valor em Saúde do Hospital Mãe de Deus</h2>
        <p style={{ width: '100%', maxWidth: '600px', margin: '20px auto', textAlign: 'justify', color: '#075E60', lineHeight: '24px', fontSize: '18px', }}>


          O I SUMMIT Internacional de Valor em Saúde do Hospital Mãe de Deus é o primeiro evento da instituição focado em Value Based Healthcare (VBHC). Seu objetivo será compartilhar as experiências na jornada de implementação do Escritório de Valor em Saúde e cocriação de linhas de cuidado com as premissas de VBHC.
          <br /><br />
          O evento contará com a palestra do presidente da American Academy of Orthopaedic Surgeons e protagonista da criação das linhas de cuidado VBHC nos EUA, Dr Kevin J. Bozic. A sócia fundadora da Academia VBHC, Dra. Marcia Makdisse, também marcará presença na atividade. Além disso, o idealizador e fundador da Justmiine, uma plataforma de cuidados integrados, com olhar assistencial em VBHC, Dr. Luciano Fochesatto é mais um especialista que integrará a programação.
          <br /><br />
          As palestras ocorrerão no formato híbrido, possibilitando a interação com o público através de perguntas, que poderão ser enviadas e respondidas ao final de cada sessão. O evento será gratuito, pois o seu principal propósito é contribuir com as instituições e profissionais de saúde, compartilhando conhecimento sobre esta temática importante.
          <br /><br />
          Para participar, é necessário se inscrever previamente para receber o certificado. Confira a programação abaixo.
        </p>
      </ContainerWhite>

      <ContainerWhite background="none" id="programacao">
        <div className="p50 tableItem">
          <h2>Programação</h2>
          <p>I Summit Internacional de Valor em Saúde do Hospital Mãe de Deus</p>
          <h2>31 de março de 2023</h2>
          <p>Presencial e online</p>
          <table>
            <tbody>
              <tr><td>8h30</td><td>Abertura </td></tr>
              <tr><td>9h</td><td>Jornada VBHC – Experiencia MSK Institute - Dr. Kevin J. Bozic, MD, MBA, FAOA, FAAOS</td></tr>
              <tr><td>10h</td><td>Intervalo</td></tr>
              <tr><td>10h30</td><td>Jornada VBHC – Experiência Hospital Mãe de Deus - Dra. Marcia Makdisse, MD, MBA, MSc, PhD e Dr. Tiago Almeida Ramos, MD, VBHC Yellow Belt, CVO e Gerente Médico Hospital Mãe Deus</td></tr>
              <tr><td> 11h30</td><td> Painel: Lições e Oportunidades para o escalonamento do VBHC
                <br />Dr. Kevin J. Bozic, MD, MBA, FAOA, FAAOS
                <br />Dra. Marcia Makdisse, MD, MBA, MSc, PhD
                <br />Dr. Tiago Almeida Ramos, MD, VBHC Yellow Belt, CVO Hospital Mãe de Deus, Gerente Médico HMD
                <br />Dr. Rafael Cremonese, MD, CEO do Hospital Mão de Deus
                <br />Dr. Luciano Fochesatto Filho - Chief Executive Officer at Justmiine
                <br />Daniela Medeiros, Superintendente de Provimento de Saúde da Unimed POA
                <br />Médicos da Bundle de Coluna do HMD



              </td></tr>


              <tr><td>13h</td><td>Encerramento </td></tr>


            </tbody>
          </table>
        </div>
      </ContainerWhite>


    </>
  );
};
export default SignIn;
